import { collection, getDocs, limit, query } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchBridgeClients() {
  const ref = collection(db, 'artifacts', appId, 'public', 'data', 'clients');
  const snap = await getDocs(query(ref, limit(50)));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
